import { DateFormatOptions, ScheduleEndMode } from '@griply/types';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { format, subDays } from 'date-fns';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './habit-schedule-confirm-end-dialog.style';

export type HabitScheduleConfirmEndDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: ScheduleEndMode) => void;
  newStartDate: Date;
  dateFormat: DateFormatOptions;
};

export const HabitScheduleConfirmEndDialog: React.FC<
  HabitScheduleConfirmEndDialogProps
> = ({ open, onClose, onConfirm, newStartDate, dateFormat }) => {
  const { t } = useTranslation();

  const dayBefore = subDays(newStartDate, 1);

  const handleConfirmToday = () => onConfirm(ScheduleEndMode.Today);
  const handleConfirmDayBefore = () => onConfirm(ScheduleEndMode.DayBefore);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant={DialogVariantOptions.ExtraSmall}
    >
      <Styled.Container>
        <Styled.Header>
          <Typography variant="h5" component="h1">
            {t('dialogs.habit-schedule.confirm-end.title')}
          </Typography>
        </Styled.Header>

        <Styled.Body>
          <Typography variant="body2">
            <Trans
              i18nKey="dialogs.habit-schedule.confirm-end.body"
              values={{ date: format(newStartDate, dateFormat) }}
              components={{ bold: <strong /> }}
            />
          </Typography>
        </Styled.Body>

        <Styled.Footer>
          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.White}
            onClick={handleConfirmToday}
            fullWidth
            alignCenter
          >
            {t('dialogs.habit-schedule.confirm-end.buttons.end-today.label')}
          </Button>

          <Button
            variant={Variants.Contained}
            size={Sizes.Medium}
            color={Colors.White}
            onClick={handleConfirmDayBefore}
            fullWidth
            alignCenter
          >
            {t('dialogs.habit-schedule.confirm-end.buttons.end-before.label', {
              date: format(dayBefore, dateFormat),
            })}
          </Button>
        </Styled.Footer>
      </Styled.Container>
    </Dialog>
  );
};
